import React from 'react';
import { connect } from 'react-redux';

import { CardDisplay } from '../utils/CardDisplay';
import Card from '../utils/Card';

import classNames from 'classnames';
import { container } from '@Container';
import { TYPES } from '@Types';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { MyDrawAction } from '@Redux/actions';
import { Draw, Nullable } from '@Models';
import { drawPresenter } from '@Selectors/tool/pairing/show/drawPresenter';
import { TeamArmyView } from '@Selectors/tool/pairing/create/view/TeamArmyView';
import { FormattedMessage } from 'react-intl';
import opponentDrawSlice from '@Redux/reducers/tool/pairing/opponentDraw.slice';
import myDrawSlice from '@Redux/reducers/tool/pairing/myDraw.slice';
import { defaultMessages } from '@I18n/default';

const DrawComponent: React.FC<DrawProps> = ({
                                              draw,
                                              confirmeMyTeamArmy,
                                              confirmeMyResponse,
                                              unSelectArmy,
                                              selectArmy,
                                              confirmeMySelection
                                            }) => {
  return (
    <div className="col-12 col-md-6 mt-2 mb-2">
      <div className="row card-armies justify-content-center">
        <Card
          display={draw.displayDraw && draw.teamArmy?.teamArmy?.armyId ? CardDisplay.DRAW : CardDisplay.DRAW_DEFAULT}
          selectable={false}
          my={draw.my}
          army={draw.teamArmy.teamArmy} />
        <div
          className="col-12 col-md-1 text-center separator p-0 mt-1 mb-1 mt-md-5 mb-md-1">
          <FormattedMessage {...defaultMessages.toolPairingDrawVs} /></div>
        <Card
          display={draw.displayResponse && draw.proposition.teamArmyOne?.armyId ? CardDisplay.DRAW_RESPONSE : CardDisplay.DRAW_DEFAULT}
          selectable={draw.proposition.teamArmyOne?.selectable ?? false}
          dropable={!draw.proposition.confirmed}
          selected={draw.proposition.teamArmyOne?.selected ?? false}
          my={!draw.my}
          army={draw.proposition.teamArmyOne}
          unSelect={() => unSelectArmy(draw.proposition.teamArmyOne)}
          select={() => selectArmy(draw.proposition.teamArmyOne)} />
        <div
          className="col-1 col-md-1 text-center separator p-0 mt-5 mt-md-1 mb-1 mt-md-5 mb-md-1">
          <FormattedMessage  {...defaultMessages.toolPairingDrawOr} /></div>
        <Card
          display={draw.displayResponse && draw.proposition.teamArmyTwo?.armyId ? CardDisplay.DRAW_RESPONSE : CardDisplay.DRAW_DEFAULT}
          selectable={draw.proposition.teamArmyTwo?.selectable ?? false}
          dropable={!draw.proposition.confirmed}
          selected={draw.proposition.teamArmyTwo?.selected ?? false}
          my={!draw.my}
          army={draw.proposition.teamArmyTwo}
          unSelect={() => unSelectArmy(draw.proposition.teamArmyTwo)}
          select={() => selectArmy(draw.proposition.teamArmyTwo)} />
      </div>
      <div className="text-center">
        <button className={classNames('btn btn-age btn-lg mt-3', { 'hidden': !draw.teamArmy.selected })}
                onClick={() => confirmeMyTeamArmy(draw.item!)}>
          <FormattedMessage {...defaultMessages.toolPairingDrawConfirmDraw} />
        </button>
        <button className={classNames('btn btn-age btn-lg mt-3', { 'hidden': !draw.proposition.selected })}
                onClick={() => confirmeMyResponse()}>
          <FormattedMessage  {...defaultMessages.toolPairingDrawConfirmResponse} />
        </button>
        <button className={classNames('btn btn-age btn-lg mt-3', { 'hidden': !draw.selection.selected })}
                onClick={() => confirmeMySelection()}>
          <FormattedMessage {...defaultMessages.toolPairingDrawConfirmSelect} />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: any) => {
  return {
    draw: drawPresenter(state, owsProps)
  };
};

const mapDispatchToProps = (dispatch: Dispatch, owsProps: any) => {
  const drawAction = container.get <MyDrawAction>(TYPES.Actions.Tool.MyDrawAction);
  return {
    confirmeMyTeamArmy: (draw: Draw) => dispatch(drawAction.selectArmyToDrawRequest(draw)),
    confirmeMyResponse: () => dispatch(drawAction.confirmArmyToDraw(owsProps.draw)),
    unSelectArmy: (proposition: Nullable<TeamArmyView>) => {
      if (!proposition) return;
      dispatch(opponentDrawSlice.actions.unselectProposition(proposition!.id!));
    },
    selectArmy: (proposition: Nullable<TeamArmyView>) => {
      if (!proposition) return;
      dispatch(myDrawSlice.actions.selectProposition(proposition!.item!));
    },
    confirmeMySelection: () => dispatch(drawAction.selectPropositionRequest())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawComponent);

type DrawProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
